@import ../../styles/helpers

*
    &::-webkit-scrollbar
        width: 12px
    &::-webkit-scrollbar-track
        background: $page_background
    &::-webkit-scrollbar-thumb
        background: $neutrals3
        border-radius: 50px
    &::-webkit-scrollbar-thumb:hover
        background: lighten( $dark_contrast, 20 )
    +m
        &::-webkit-scrollbar
            display: none

.page
    overflow: hidden
    height: 100vh
    display: flex
    flex-direction: column
    +m
        position: absolute
        height: 100%
        width: 100%
        top: 0
        left: 0

.hide
    display: none !important

.inner
    height: calc(100% - $header_height)
    width: 100%
    display: flex
    overflow-y: auto
    overflow-x: hidden
    +m
        margin-bottom: $icon_size
        height: calc(100% - $header_height - $external_margin * 2)
    &.chat
        overflow: visible !important

.side_section
    width: $sidebar_size
    height: 100%
    text-align: center
    justify-content: center
    display: flex
    position: relative
    flex-shrink: 0

.column_center
    height: 100%
    flex-grow: 1
    width: 100%
    padding-right: calc( $external_margin / 2 )
    padding-left: $external_margin
    +m
        margin-left: 0px
        margin-right: 0px
        padding-left: calc( $external_margin / 2 )
    &>div
        padding-bottom: $external_margin

.column_left
    @extend .side_section
.column_right
    +m
        display: none
